export const CONTACT = {
  phone: "+91 7208268506",
  phoneHref: "tel:+917208268506",
  email: "organtransplantcare@gmail.com",
  address: ["Comprehensive Organ Transplant Care (COTC) Pvt. Ltd.", "201, City Center 2", "Near Panchamrut Bunglows 2", "Sola, Ahmedabad – 380060", "Gujarat, India"],
};

export default function ContactBlock({ dark = false }) {
  const muted = dark ? "text-neutral-400" : "text-neutral-500";
  const strong = dark ? "text-neutral-100" : "text-ink";
  return (
    <div className="space-y-4 text-sm">
      <div>
        <div className={`text-[11px] font-mono uppercase tracking-widest ${muted} mb-1`}>Phone</div>
        <a data-testid="contact-phone" href={CONTACT.phoneHref} className={`${strong} hover:text-rust transition-colors`}>
          {CONTACT.phone}
        </a>
      </div>
      <div>
        <div className={`text-[11px] font-mono uppercase tracking-widest ${muted} mb-1`}>Email</div>
        <a data-testid="contact-email" href={`mailto:${CONTACT.email}`} className={`${strong} hover:text-rust transition-colors break-all`}>
          {CONTACT.email}
        </a>
      </div>
      <div>
        <div className={`text-[11px] font-mono uppercase tracking-widest ${muted} mb-1`}>Address</div>
        <address className={`not-italic ${dark ? "text-neutral-300" : "text-neutral-600"} leading-relaxed`}>
          {CONTACT.address.map((l) => <div key={l}>{l}</div>)}
        </address>
      </div>
    </div>
  );
}
